"use strict";

define('components/filter_bar/table/bulk_assign_to',['components/ajax'], function(ajax) {
    var bulkAssignToComponent = {
        initWithContext: function(context) {
            // Click handler for the assign-to action menu items.
            var allAssignToLinks = context.buttonbarNode.find('li.assign-to');
            allAssignToLinks.click(function(e) {
                var assignTo = $(this);
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();

                var formData = new FormData();
                formData.append('object_type', context.tableFilterBarData.tableObjectType);
                formData.append('object_ids', JSON.stringify(objectIds));

                ajax(assignTo.data('add-url'), {
                    formData: formData
                });
            });
        }
    };

    return bulkAssignToComponent;
});

